<template>
  <footer class="footer">
    <div class="container">
      <img src="../assets/logo.jpg" alt="ADLCJ" class="logoFooter" />
      <router-link to="/adlcj">{{ $t("adlcj.h1") }}</router-link>
      <div class="footerGroup">
        <router-link to="/mentions-legales">Mentions légales</router-link>
        <router-link to="/contact">Contact</router-link>
        <a href="https://www.facebook.com/Adlcjlyonhoshujyugyoko/" target="_blank" rel="noopener">
          <img src="../assets/image/icons/ic_baseline-facebook.svg" alt="Facebook" />
        </a>
      </div>
    </div>
    <p>Tous droits réservés. {{ currentYear }} © ADLCJ</p>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss">
.logoFooter {
  width: 80px;
  margin-bottom: 0.9rem;
}
.footer {
  background-color: transparent;
  color: black;
  font-size: 14px;
  margin-top: 50px;
  padding: 10px 0;
  > .container {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin-bottom: 1rem;
  }
  p {
    font-size: 13px;
    margin: 0 20px 0 0;
  }
  a {
    color: black;
    font-weight: 400;
    font-size: 13px;
    padding: 5px;
    &:hover {
      color: rgba($color: black, $alpha: 0.7);
      text-decoration: none;
    }
  }
}

.footerGroup {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}
</style>
